import { Cross2Icon } from "@radix-ui/react-icons";
import { useRef } from "react";
import IconTip from "./IconTip";

/**
 * A gray X: one click takes the row out of the list. It dismisses its own
 * row once: a click on a row already leaving does nothing, and so does the
 * rest of a double-click (it lands on the row that moved up under it).
 */
export default function DismissButton({
  onDismiss,
}: {
  onDismiss: () => void;
}) {
  const leaving = useRef(false);
  return (
    <IconTip label="Dismiss">
      <button
        type="button"
        className="people-panel__icon"
        aria-label="Dismiss"
        onClick={(e) => {
          // A key press has detail 0; a double-click's second click, 2.
          if (leaving.current || e.detail > 1) return;
          leaving.current = true;
          onDismiss();
        }}
      >
        <Cross2Icon />
      </button>
    </IconTip>
  );
}
